const IsleOfManSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111645)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M27.4053 13.4064L25.9917 18.451L21.7503 17.6678L19.0202 12.04L11.6446 14.6573L11.063 13.0182L9.1333 12.7805L10.5873 16.8781L15.663 15.58L17.1054 19.6448L13.5967 24.8231L19.5511 29.9017L18.4225 31.2249L19.1814 33.015L22.0031 29.7069L18.3411 25.9603L21.1401 22.6788L27.379 23.1283L28.8 15.4322L30.5103 15.7481L31.6813 14.1957L27.4053 13.4064Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111645">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IsleOfManSvg;
